'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaults = require('lodash/defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _lang = require('./lang');

var translations = _interopRequireWildcard(_lang);

var _package = require('../package.json');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cookieName = 'cookiesAccepted';
var locale = {
  default: 'en',
  current: null
};
/**
 * Sets the cookie accepting the terms.
 *
 * @param {String} name
 * @return {void}
 */

var setCookie = function setCookie() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cookieName;
  var date = new Date(new Date().setFullYear(new Date().getFullYear() + 10));
  document.cookie = name + '=1; path=/; expires=' + date.toUTCString() + '; SameSite=Strict';
};
/**
 * Checks if the terms cookie is present.
 *
 * @param {String} name
 * @return {Boolean}
 */


var hasCookie = function hasCookie() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cookieName;
  return document.cookie.split('; ').reduce(function (previous, value) {
    var parts = value.split('=');
    return parts[0] === name ? true : previous;
  }, false);
};
/**
 * Remove the notice html element.
 *
 * @param {Object} noticeDiv
 * @return {void}
 */


var removeNotice = function removeNotice(noticeDiv) {
  noticeDiv.parentNode.removeChild(noticeDiv);
  setCookie(cookieName);
};
/**
 * Set the current locale.
 *
 * @param {String} newLocale
 * @return {void}
 */


var setLocale = function setLocale(newLocale) {
  locale.current = newLocale || locale.default;
};
/**
 * Translates a string from the localization files stored within `/lang`
 * using the given key. Fallbacks to default locale or the given key if
 * nothing could be resolved.
 *
 * @param {String} key
 * @return {String}
 */
// eslint-disable-next-line no-underscore-dangle


var __ = function __(key) {
  var fallback = (0, _get2.default)(translations, locale.default + '.' + key, key);
  return (0, _get2.default)(translations, locale.current + '.' + key, fallback);
};
/**
 * Create the notice html element and append to the body tag.
 * An override of the local translations can be optionally passed.
 *
 * @param {String|null} notice
 * @param {String|null} button
 * @return {void}
 */


var showNotice = function showNotice() {
  var notice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var button = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var noticeDiv = document.createElement('div');
  noticeDiv.className = 'cookie-wrapper';
  var containerDiv = document.createElement('div');
  containerDiv.className = 'cookie-container';
  var rowDiv = document.createElement('div');
  rowDiv.className = 'cookie';
  var rowColMain = document.createElement('div');
  rowColMain.className = 'cookie__col cookie__col--grow';
  var rowColButton = document.createElement('div');
  rowColButton.className = 'cookie__col cookie__col--centre';
  var noticeButton = document.createElement('button');
  noticeButton.className = 'cookie__btn'; // eslint-disable-next-line no-underscore-dangle

  noticeButton.innerHTML = button || __('button');

  noticeButton.onclick = function () {
    return removeNotice(noticeDiv);
  };

  var noticeTextP = document.createElement('p');
  noticeTextP.className = 'cookie__notice'; // eslint-disable-next-line no-underscore-dangle

  noticeTextP.innerHTML = notice || __('notice');
  rowColMain.appendChild(noticeTextP);
  noticeDiv.appendChild(containerDiv);
  containerDiv.appendChild(rowDiv);
  rowDiv.appendChild(rowColMain);
  rowDiv.appendChild(rowColButton);
  rowColButton.appendChild(noticeButton);
  document.body.appendChild(noticeDiv);
};

exports.default = {
  getVersion: function getVersion() {
    return _package.version;
  },
  init: function init() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = (0, _defaults2.default)(params, {
      locale: locale.default,
      notice: null,
      button: null
    });

    if ((0, _isNil2.default)(config)) {
      throw new Error('cookie-notice.js configuration must be an object.');
    }

    setLocale(config.locale);

    if (!hasCookie(cookieName)) {
      showNotice(config.notice, config.button);
    }
  },
  hasCookie: hasCookie,
  setCookie: setCookie
};
module.exports = exports['default'];